customElements.component = "product-description";

if (!customElements.get(customElements.component)) {
  class ProductDescription extends HTMLElement {
    constructor() {
      super();
      
      this.tabs = this.querySelectorAll(".js-product-description-tab-input");
      this.tabContents = this.querySelectorAll(".js-product-description-tab-content");
      this.accordionTitles = this.querySelectorAll(".js-product-description-accordion-title");
    }

    connectedCallback() {
      this.setEventListeners();
    }

    disconnectedCallback() {
      this.tabs.forEach(tab => {
        tab.removeEventListener("change", this.handleTabChange.bind(this));
      });

      this.accordionTitles.forEach(title => {
        title.removeEventListener("click", this.handleAccordionTitleClick.bind(this));
      });
    }

    setEventListeners() {
      this.tabs.forEach(tab => {
        tab.addEventListener("change", this.handleTabChange.bind(this));
      });

      this.accordionTitles.forEach(title => {
        title.addEventListener("click", this.handleAccordionTitleClick.bind(this));
      });
    }

    handleTabChange(event) {
      const tab = event.target.closest(".js-product-description-tab-input");
      if (!tab) return;
      const currentTabValue = tab.value;
      
      this.tabContents.forEach(content => {
        if (content.dataset.tabContent === currentTabValue) {
          content.classList.add("is-active");
        } else {
          content.classList.remove("is-active");
        }
      });
    }

    handleAccordionTitleClick(event) {
      const title = event.target.closest(".js-product-description-accordion-title");
      if (!title) return;
      
      this.accordionTitles.forEach(otherTitle => {
        if (otherTitle !== title) {
          otherTitle.classList.remove("is-active");
          const otherPanel = otherTitle.nextElementSibling;
          if (otherPanel.style.maxHeight) {
            otherPanel.style.maxHeight = null;
          }
        }
      });
      
      title.classList.toggle("is-active");
      const panel = title.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    }
  }

  customElements.define(customElements.component, ProductDescription);
}